<template>
  <div class="adviser-enrolment-wrapper">
    <div class="adviser-enrolment-content">
      <div class="mb-12">
        <h1>Why Wills Matter</h1>
        <p>
          <strong>70% of South Africans don't have a will,</strong> leaving
          their <strong>families vulnerable</strong> when the unexpected
          happens. As trusted financial advisers,
          <strong>you have the power to change this.</strong>
        </p>
        <p>
          Through the <strong>Old Mutual Will platform</strong>, we're making it
          easier than ever to help clients
          <strong
            >protect their legacy and provide for their loved ones.</strong
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdviserEnrolmentIntro",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.adviser-enrolment-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 80px;
}

.adviser-enrolment-content {
  width: 100%;
  max-width: 768px;
  justify-self: center;
  position: relative;
  z-index: 1;
}

section {
  margin-bottom: 60px;
}

.semi-bold {
  font-weight: 600 !important;
}
.article-link {
  color: #282828;
  font-weight: 500;
}

h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 24px;
  &.intro {
    font-size: 22px;
    font-weight: 400;
    line-height: 26px;
  }
}
h2 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 22px;
  line-height: 26px;
  margin: 40px 0 24px 0;
  &.sub-heading-one {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
  &.sub-heading-two {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  &.om-green {
    color: #50b848;
  }
}

.article-cta {
  color: #50b848;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  a {
    color: #50b848;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }
}
p,
ul,
li {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
}
blockquote {
  color: #50b848;
  border-left: 4px solid #50b848;
  padding-left: 24px;
  font-size: 22px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  margin: 40px 0;
  ul {
    li {
      list-style-type: disc;
      font-family: "Montserrat", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      text-align: left;

      &::marker {
        color: #50b848;
      }
    }
    p {
      color: #282828;
      font-family: "Montserrat", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
    }
    &.no-paragraphs {
      li {
        color: #282828;
      }
    }
  }
}
ul {
  margin: 24px 0;
  p {
    margin: 10px 0;
  }
}

.faq-category {
  margin-bottom: 40px;

  .faq-item {
    margin-bottom: 24px;
  }
}
</style>
